<template>
  <v-container class="d-flex align-center justify-center fluid fill-height">
    <v-card outlined width="350" tile>
      <v-card-title>
        Forgot Password?
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form v-model="isValid" ref="form">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            type="email"
            label="Enter Your Email"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn block class="primary" @click="login" depressed tile>
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { auth } from "../assets/js/firebase.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      isValid: false,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      isAuth: false,
      email: ""
    };
  },
  methods: {
    login() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      vm.$root.loader = true;
      auth
        .sendPasswordResetEmail(vm.email)
        .then(() => {
          vm.$root.loader = false;
          vm.email = "";
          vm.password = "";
          vm.$root.alert(
            "We have sent a password reset link to your E-mail",
            "Note"
          );
        })
        .catch(({ message }) => {
          vm.$root.loader = false;
          vm.$root.alert(message);
        });
    }
  }
};
</script>
<style></style>
